// Angular 2
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/forms';
import '@angular/http';
import '@angular/router';

import 'rxjs';
import '@angularclass/hmr';
import 'bootstrap/dist/css/bootstrap.css';

// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/vendor.ts